<template lang="html">
    <div>
        <form @submit.prevent="addCallTrackingPlatform">
            <div class="form-group">
                <label for="vendor">Platform</label>
                <select class="form-control" v-model="form.platform"> 
                    <option :value="null">Select a Platform</option>
                    <option value="Mongoose">Mongoose</option>
                    <option value="AdWords">AdWords</option>
                </select>
            </div>
            <!-- <div v-show="form.platfrom != null"> -->
                <div class="form-group">
                    <label for="account_id">Account ID</label>
                    <input class="form-control" type="text" v-model="form.account_id" name="account_id">
                </div>
                <div class="form-group" v-if="form.platform != 'AdWords'">
                    <label for="token">Access Token</label>
                    <input class="form-control" type="text" v-model="form.token" name="token">
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">Add Platform</button>
                </div>
            <!-- </div> -->
        </form>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        data() {
            return {
                form: {
                    platform: null,
                    account_id: '',
                    token: null,
                    token_id: null,
                    client_id: null,
                },

                loading: false
            }
        },

        computed: {
            ...mapGetters('client', {
                'client': 'activeClient',
                'isAdmin': 'isAdmin',
            }),
        },

        methods: {

            addCallTrackingPlatform() {
                this.loading = true;

                let platform = this.form;
                platform.client_id = this.client.id;

                if (platform.platform == 'AdWords') {
                    platform.token_id = 'adwords';
                }

                this.$store.dispatch('client/addCallTrackingPlatform', {
                        platform: platform
                    })
                    .then((response) => {
                        Bus.$emit('show-success-alert', response.message);
                        Bus.$emit('call-tracking-platform-added');
                        this.reset();
                    }).catch((error) => {
                        console.log(error.data);
                        this.loading = false;
                    });

            },

            reset() {
                Object.assign(this.$data, this.$options.data());
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/clients/NewCallTrackingPlatformForm.vue